import styled, { css } from "styled-components"
import SearchBox from "./search-box"

const open = css`
  width: 100%;
  max-width: 24rem;
  cursor: text;
  padding-left: 2.5rem;
  height: auto;
`

const closed = css`
`

export default styled(SearchBox)`

  .SearchInput {
    ${({ hasFocus }) => (hasFocus ? open : closed)}
  }
`